query branchUserList {
  branchUserList(orderBy: NAME_ASC) {
    nodes {
      id
      name
      _activeApprovalCount
    }
  }
}
